import React from 'react'
import { PATH } from './constants/router'

const LoginByApikey = React.lazy(() => import('./page/LoginByApikey'))
const Home = React.lazy(() => import('./page/Home'))
const TaxLookupMst = React.lazy(() => import('./page/TaxCDS/TaxLookupMst'))
const IframeView = React.lazy(() => import('./page/IframeView'))
const MaintenancePage = React.lazy(() => import('./page/Maintenance/index'))
const TaxLookupObligation = React.lazy(() => import('./page/TaxCDS/TaxLookupObligation'))
const TaxLookupHkdStatus = React.lazy(() => import('./page/TaxCDS/TaxLookupHkdStatus'))
const TaxLookupFinalization = React.lazy(() => import('./page/TaxCDS/TaxLookupFinalization'))
const TaxLookupDeclarationStatus = React.lazy(() => import('./page/TaxCDS/TaxLookupDeclarationStatus'))
const TaxLookupRefund = React.lazy(() => import('./page/TaxCDS/TaxLookupRefund'))
const ProfilePage = React.lazy(() => import('./page/TaxCDS/Profile'))
const PersonalInfoPage = React.lazy(() => import('./page/TaxCDS/PersonalInfo'))
const ChangePasswordPage = React.lazy(() => import('./page/TaxCDS/ChangePassword'))
const CooperationPage = React.lazy(() => import('./page/TaxCDS/Cooperation'))
const CustomerSupportPage = React.lazy(() => import('./page/TaxCDS/CustomerSupport'))
const FeedbackPage = React.lazy(() => import('./page/TaxCDS/Feedback'))
const TermsPolicyPage = React.lazy(() => import('./page/TaxCDS/TermsPolicy'))
const PrivatePolicyPage = React.lazy(() => import('./page/TaxCDS/PrivacyPolicy'))
const PaymentPolicyPage = React.lazy(() => import('./page/TaxCDS/PaymentPolicy'))
const GeneralTermsPage = React.lazy(() => import('./page/TaxCDS/GeneralTerms'))
const TaxLookupExitBan = React.lazy(() => import('./page/TaxCDS/TaxLookupExitBan'))
const TaxNotification = React.lazy(() => import('./page/TaxCDS/TaxNotification'))

const TaxNotificationDetail = React.lazy(() => import('./page/TaxCDS/TaxNotificationDetail'))

export const ROUTERS = {
  loginByApikey: {
    path: PATH.LOGIN_BY_APIKEY,
    component: LoginByApikey,
    exact: true,
  },
  home: {
    path: PATH.HOME,
    component: Home,
    exact: true
  },
  iframeView: {
    path: PATH.IFRAME_VIEW,
    component: IframeView
  },
  taxLookupMst: {
    path: PATH.TAX_LOOKUP_MST,
    component: TaxLookupMst
  },
  taxLookupFinalization: {
    path: PATH.TAX_LOOKUP_FINALIZATION,
    component: TaxLookupFinalization
  },
  taxLookupObligation: {
    path: PATH.TAX_LOOKUP_OBLIGATION,
    component: TaxLookupObligation
  },
  taxLookupHkdStatus: {
    path: PATH.TAX_LOOKUP_HKD_STATUS,
    component: TaxLookupHkdStatus
  },
  taxLookupDeclarationStatus: {
    path: PATH.TAX_LOOKUP_DECLARATION_STATUS,
    component: TaxLookupDeclarationStatus
  },
  taxLookupRefund: {
    path: PATH.TAX_LOOKUP_REFUND,
    component: TaxLookupRefund
  },
  taxLookupExitBan: {
    path: PATH.TAX_LOOKUP_EXIT_BAN,
    component: TaxLookupExitBan,
  },
  taxNotification: {
    path: PATH.TAX_NOTIFICATION,
    component: TaxNotification,
    exact: true,
  },
  taxNotificationDetail: {
    path: PATH.TAX_NOTIFICATION_DETAIL,
    component: TaxNotificationDetail,
    exact: true,
  },
  maintenanceWeb: {
    path: PATH.MAINTENANCE,
    component: MaintenancePage
  },
  profile: {
    path: PATH.PROFILE,
    component: ProfilePage
  },
  personalInfo: {
    path: PATH.PERSONAL_INFO,
    component: PersonalInfoPage
  },
  ChangePassword: {
    path: PATH.CHANGE_PASSWORD,
    component: ChangePasswordPage
  },
  Cooperation: {
    path: PATH.COOPERATION,
    component: CooperationPage
  },
  CustomerSupport: {
    path: PATH.CUSTOMER_SUPPORT,
    component: CustomerSupportPage
  },
  Feeback: {
    path: PATH.FEEDBACK,
    component: FeedbackPage
  },
  Term: {
    path: PATH.TERM,
    component: TermsPolicyPage
  },
  PrivatePolicy: {
    path: PATH.PRIVATE_INFORMATION_POLICY,
    component: PrivatePolicyPage
  },
  PaymentPolicy: {
    path: PATH.PAYMENT_POLICY,
    component: PaymentPolicyPage
  },
  GeneralTerm: {
    path: PATH.GENERAL_TERM,
    component: GeneralTermsPage
  }
}
